import { Box } from "@mui/system";
import IncomeTabs from "./IncomeTabs";

const Income = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <IncomeTabs />
      </Box>
    </>
  );
};

export default Income;
